export default __webpack_public_path__ + "static/media/timeline-09.cdd489c0.png";